$(document).on('click', '.dnJs-optOutLink', function(e) {
    var link = $(this);
    var type = link.data('type');

    createCookie(type, 1, 365*50);

    e.preventDefault();
    window.alert(link.data('ok-text'));
    location.reload();
});

$(document).on('click', '.dnJs-optOutLink-revert', function(e) {
    var link = $(this);
    var type = link.data('type');

    deleteCookie(type);

    e.preventDefault();
    window.alert(link.data('ok-text'));
    location.reload();
});